import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { Phone, Mail, MapPin, Linkedin, Twitter, Instagram, ArrowRight } from 'lucide-react';
export const Contact = () => {
  return <main className="pt-24 bg-brand-warm-white min-h-screen" data-id="element-143">
      {/* Hero */}
      <section className="bg-brand-navy py-24 text-white relative overflow-hidden" data-id="element-144">
        <div className="absolute inset-0 opacity-10" data-id="element-145">
          <div className="absolute inset-0 bg-[url('https://cdn.magicpatterns.com/patterns/generated-images/71a47677-f75f-4223-9322-a9cb08464282.jpg')] bg-cover bg-center" data-id="element-146" />
        </div>
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} className="max-w-7xl mx-auto px-6 relative z-10" data-id="element-147">
          <span className="text-brand-gold font-bold tracking-widest uppercase text-sm mb-6 block" data-id="element-148">
            Contact Us
          </span>
          <h1 className="text-5xl md:text-7xl font-display mb-8" data-id="element-149">
            Begin Your <br data-id="element-150" />
            <span className="italic text-brand-gold" data-id="element-151">Consultation</span>.
          </h1>
          <p className="text-xl text-white/70 max-w-2xl leading-relaxed" data-id="element-152">
            Our partners are ready to discuss your strategic goals and financial
            complexities. Connect with us to explore how we can drive your
            growth.
          </p>
        </motion.div>
      </section>

      <section className="py-24" data-id="element-153">
        <div className="max-w-7xl mx-auto px-6" data-id="element-154">
          <div className="grid lg:grid-cols-2 gap-20" data-id="element-155">
            {/* Contact Info */}
            <motion.div initial={{
            opacity: 0,
            x: -30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8
          }} className="space-y-16" data-id="element-156">
              <div data-id="element-157">
                <h2 className="text-3xl font-display text-brand-navy mb-12" data-id="element-158">
                  Direct Channels
                </h2>
                <div className="space-y-10" data-id="element-159">
                  <div className="flex gap-8" data-id="element-160">
                    <div className="w-14 h-14 rounded-2xl bg-brand-navy flex items-center justify-center text-brand-gold shrink-0" data-id="element-161">
                      <Phone size={24} data-id="element-162" />
                    </div>
                    <div data-id="element-163">
                      <div className="text-xs uppercase tracking-widest text-brand-charcoal/40 mb-2 font-bold" data-id="element-164">
                        Call Our Partners
                      </div>
                      <div className="text-2xl font-medium text-brand-navy" data-id="element-165">
                        240-882-3949
                      </div>
                      <div className="text-sm text-brand-charcoal/40 mt-1" data-id="element-166">
                        Mon - Fri, 9am - 6pm EST
                      </div>
                    </div>
                  </div>
                  <div className="flex gap-8" data-id="element-167">
                    <div className="w-14 h-14 rounded-2xl bg-brand-navy flex items-center justify-center text-brand-gold shrink-0" data-id="element-168">
                      <Mail size={24} data-id="element-169" />
                    </div>
                    <div data-id="element-170">
                      <div className="text-xs uppercase tracking-widest text-brand-charcoal/40 mb-2 font-bold" data-id="element-171">
                        Email Our Advisory
                      </div>
                      <div className="text-2xl font-medium text-brand-navy" data-id="element-172">
                        Emmanuel@consiliumadvisory.com
                      </div>
                      <div className="text-sm text-brand-charcoal/40 mt-1" data-id="element-173">
                        We respond within 24 hours
                      </div>
                    </div>
                  </div>
                  <div className="flex gap-8" data-id="element-174">
                    <div className="w-14 h-14 rounded-2xl bg-brand-navy flex items-center justify-center text-brand-gold shrink-0" data-id="element-175">
                      <MapPin size={24} data-id="element-176" />
                    </div>
                    <div data-id="element-177">
                      <div className="text-xs uppercase tracking-widest text-brand-charcoal/40 mb-2 font-bold" data-id="element-178">
                        Visit Our Office
                      </div>
                      <div className="text-2xl font-medium text-brand-navy" data-id="element-179">
                        13635 Old Annapolis Road, <br data-id="element-180" />
                        Bowie, MD 20706
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div data-id="element-181">
                <h2 className="text-3xl font-display text-brand-navy mb-8" data-id="element-182">
                  Global Presence
                </h2>
                <div className="grid grid-cols-2 gap-8" data-id="element-183">
                  <div className="p-8 rounded-3xl bg-white border border-brand-navy/5 shadow-sm" data-id="element-184">
                    <h4 className="font-heading font-bold text-brand-navy mb-2" data-id="element-185">
                      United States
                    </h4>
                    <p className="text-sm text-brand-charcoal/60 leading-relaxed" data-id="element-186">
                      Maryland HQ & Strategic Hub
                    </p>
                  </div>
                  <div className="p-8 rounded-3xl bg-white border border-brand-navy/5 shadow-sm" data-id="element-187">
                    <h4 className="font-heading font-bold text-brand-navy mb-2" data-id="element-188">
                      Nigeria
                    </h4>
                    <p className="text-sm text-brand-charcoal/60 leading-relaxed" data-id="element-189">
                      Lagos Regional Advisory
                    </p>
                  </div>
                </div>
              </div>

              <div data-id="element-190">
                <h2 className="text-3xl font-display text-brand-navy mb-8" data-id="element-191">
                  Follow Our Insights
                </h2>
                <div className="flex gap-4" data-id="element-192">
                  <a href="#" className="w-12 h-12 rounded-full bg-white border border-brand-navy/5 flex items-center justify-center text-brand-navy hover:bg-brand-gold hover:text-white transition-all" data-id="element-193">
                    <Linkedin size={20} data-id="element-194" />
                  </a>
                  <a href="#" className="w-12 h-12 rounded-full bg-white border border-brand-navy/5 flex items-center justify-center text-brand-navy hover:bg-brand-gold hover:text-white transition-all" data-id="element-195">
                    <Twitter size={20} data-id="element-196" />
                  </a>
                  <a href="#" className="w-12 h-12 rounded-full bg-white border border-brand-navy/5 flex items-center justify-center text-brand-navy hover:bg-brand-gold hover:text-white transition-all" data-id="element-197">
                    <Instagram size={20} data-id="element-198" />
                  </a>
                </div>
              </div>
            </motion.div>

            {/* Form */}
            <motion.div initial={{
            opacity: 0,
            x: 30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8
          }} className="bg-white p-12 lg:p-16 rounded-[40px] shadow-2xl border border-brand-navy/5" data-id="element-199">
              <h2 className="text-3xl font-display text-brand-navy mb-8" data-id="element-200">
                Send an Inquiry
              </h2>
              <form className="space-y-8" data-id="element-201">
                <div className="grid md:grid-cols-2 gap-8" data-id="element-202">
                  <div className="space-y-3" data-id="element-203">
                    <label className="text-xs uppercase tracking-widest font-bold text-brand-navy" data-id="element-204">
                      Full Name
                    </label>
                    <input type="text" className="w-full bg-brand-warm-white border-none p-5 rounded-2xl focus:ring-2 focus:ring-brand-gold outline-none transition-all" placeholder="John Doe" data-id="element-205" />
                  </div>
                  <div className="space-y-3" data-id="element-206">
                    <label className="text-xs uppercase tracking-widest font-bold text-brand-navy" data-id="element-207">
                      Email Address
                    </label>
                    <input type="email" className="w-full bg-brand-warm-white border-none p-5 rounded-2xl focus:ring-2 focus:ring-brand-gold outline-none transition-all" placeholder="john@company.com" data-id="element-208" />
                  </div>
                </div>
                <div className="space-y-3" data-id="element-209">
                  <label className="text-xs uppercase tracking-widest font-bold text-brand-navy" data-id="element-210">
                    Subject
                  </label>
                  <select className="w-full bg-brand-warm-white border-none p-5 rounded-2xl focus:ring-2 focus:ring-brand-gold outline-none transition-all appearance-none" data-id="element-211">
                    <option data-id="element-212">Tax & Accounting</option>
                    <option data-id="element-213">Strategic Advisory</option>
                    <option data-id="element-214">Capital Solutions</option>
                    <option data-id="element-215">Other Inquiry</option>
                  </select>
                </div>
                <div className="space-y-3" data-id="element-216">
                  <label className="text-xs uppercase tracking-widest font-bold text-brand-navy" data-id="element-217">
                    Message
                  </label>
                  <textarea rows={6} className="w-full bg-brand-warm-white border-none p-5 rounded-2xl focus:ring-2 focus:ring-brand-gold outline-none transition-all" placeholder="How can we help you?" data-id="element-218" />
                </div>
                <button className="w-full bg-brand-navy text-white py-6 rounded-2xl text-sm font-bold tracking-widest uppercase hover:bg-brand-gold transition-all flex items-center justify-center gap-4" data-id="element-219">
                  Submit Inquiry <ArrowRight size={18} data-id="element-220" />
                </button>
              </form>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Interactive Map */}
      <section className="h-[500px] bg-brand-navy/5 relative overflow-hidden" data-id="element-221">
        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 1
      }} className="absolute inset-0" data-id="element-222">
          <iframe title="Consilium Advisory Office Location" src="https://maps.google.com/maps?q=13635%20Old%20Annapolis%20Road%20Bowie,%20MD%2020706&t=&z=13&ie=UTF8&iwloc=&output=embed" width="100%" height="100%" style={{
          border: 0
        }} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" data-id="element-223" />
        </motion.div>
      </section>
    </main>;
};